import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { pixelCorners, pixelShadow } from '../pixel/pixelUI'

const Logo = styled(Link)`
  display: inline-block;
  flex: 0 0 auto;
  font-family: ${(props) => props.theme.pixelFont};
  font-size: 1.1rem;
  color: #fff;
  background: ${(props) => props.theme.blossom};
  border: 3px solid ${(props) => props.theme.black};
  ${pixelCorners(5)}
  ${(props) => pixelShadow(4, 4)}
  padding: 0.6rem 0.8rem;
  text-decoration: none;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid ${(props) => props.theme.black};
    outline-offset: 4px;
  }

  ${(props) =>
    props.$inline
      ? ''
      : `
  position: fixed;
  left: 1.5rem;
  top: 1.5rem;
  `}
  z-index: 10;
`

// Pass `inline` when the logo should sit in normal flow next to other
// content (e.g. inside PageHeader) instead of being pinned to the viewport.
const LogoComponent = ({ inline }) => {
    return (
        <Logo to="/" $inline={inline} aria-label="Return to homepage">
          HT
        </Logo>
    )
}

export default LogoComponent
